var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackCarousel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3994 23.2002L25.2119 31.0127C25.323 31.1162 25.4699 31.1726 25.6217 31.1699C25.7735 31.1672 25.9183 31.1057 26.0256 30.9984C26.133 30.891 26.1945 30.7462 26.1972 30.5944C26.1999 30.4426 26.1435 30.2957 26.04 30.1846L18.6425 22.7862L26.04 15.3877C26.1435 15.2767 26.1999 15.1297 26.1972 14.9779C26.1945 14.8261 26.133 14.6813 26.0256 14.574C25.9183 14.4666 25.7735 14.4051 25.6217 14.4024C25.4699 14.3998 25.323 14.4561 25.2119 14.5596L17.3994 22.3721C17.2897 22.482 17.228 22.6309 17.228 22.7862C17.228 22.9414 17.2897 23.0904 17.3994 23.2002Z",
    fill: "#383838"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    transform: "matrix(-1 0 0 1 44 0.285156)",
    stroke: "#383838"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCarousel);
export default __webpack_public_path__ + "static/media/back-carousel.d69865a5989f98bb257c5284cb14e868.svg";
export { ForwardRef as ReactComponent };